<!-- eslint-disable -->
<template lang="pug">
    .playground
        .row.playground__flex-center
            .playground__col-padding(:class="isVerticalScreen ? 'col-xs-6 col-sm-6' : 'col-xs-3 col-sm-3'")
                .playground__img
                    img(:src="mainItem | apiFile")
            .playground__col-padding(:class="isVerticalScreen ? 'col-xs-6 col-sm-6' : 'col-xs-9 col-sm-9'")
                .playground__title
                    | {{ helpText }}
        .playground__items.row
            .playground__col-padding(v-for="(item, index) in items" :key="item" :class="isVerticalScreen ? 'col-xs-6 col-sm-6' : 'col-xs-3 col-sm-3'")
                .playground__item(ref="playgroundItems")
                    img(:src="item | apiFile" @click="onClickItem(item, index)")
</template>

<script>
    export default {
        props: {
            items: {
                items: Array,
                default: [],
            },
            mainItem: {
                items: String,
                required: true,
            },
            helpText: {
                items: String,
                required: true,
            },
            isVerticalScreen: {
                items: Boolean,
                required: true,
            },
        },
        methods: {
            onClickItem(item, index) {
                this.$emit('selectItem', item, this.$refs.playgroundItems[index]);
            },
        },
    };
</script>

<style scoped lang="scss">
    .playground {
        &__text-center {
            text-align: center;
        }

        &__flex-center {
            align-items: center;
            justify-content: center;
        }

        &__title {
            font-weight: bold;
            @media (orientation: landscape) {
                font-size: calc(100vw / 50 + 5px);
                line-height: calc(100vw / 50 + 5px);
            }
            @media (orientation: portrait) {
                font-size: 7px;
                line-height: 7px;
                @media (min-width: 200px) {
                    font-size: calc(100vw / 60 + 5px);
                    line-height: calc(100vw / 60 + 5px);
                }
                @media (min-width: 300px) {
                    font-size: calc(100vw / 40 + 5px);
                    line-height: calc(100vw / 40 + 5px);
                }
            }
        }

        &__img {
            border: 2px solid #e7e7f8;
            border-radius: 10px;
            background-color: white;
            padding: 10px;
        }

        &__items {
            margin-top: 5px;
        }

        &__col-padding {
            padding: 5px;
            @include media($md) {
                padding: 10px;
            }
            @include media($lg) {
                padding: 15px;
            }
            @include media($xlg) {
                padding: 20px;
            }
        }

        &__item {
            border: 2px solid $hsl-color-gray-94;
            border-radius: $border-radius-10;
            background-color: $x-color-white;
            padding: 10px;
            cursor: pointer;
            user-select: none;
            box-sizing: border-box;
        }

        &__item--correct {
            pointer-events: none;
            border: 2px solid $hsl-color-green-58;
        }
    }

    img {
        width: 100%;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
